import Reflux from 'reflux';
import VideoEvents from './video-events';
import AmpPlayerEvents from './amp-player-events';
import $ from 'jquery';
/*
  VideoActionsFactory

  Creates Reflux Actions for each video.
  Prevents multiple videos from listening and triggering the same actions.
*/
class VideoActionsFactory {
  constructor() {
    this.actions = {};
    this.VideoPlayerEvents = [].concat(VideoEvents);
    AmpPlayerEvents.forEach( (playerEvent)=>{
      if(this.VideoPlayerEvents.indexOf(playerEvent)<0) {
        this.VideoPlayerEvents.push(playerEvent);
      }
    });
  }
  get(videoId, route) {
    const key = `${videoId}${route.location.pathname}`;
    if(!this.actions[key]) {
      this.actions[key] = Reflux.createActions(this.VideoPlayerEvents);
      this.actions[key].timeStamp = Date.now();
    }
    return this.actions[key];
  }
  clearCache() {
    Object.keys(this.actions).forEach((key)=> {
      delete this.actions[key]
    });
  }
}
export default new VideoActionsFactory();



// WEBPACK FOOTER //
// ./medscape_modules/video/video-actions-factory.js